import styled from 'styled-components';

const ThumbGridStyles = styled.div``;

export default ThumbGridStyles;
